module.exports = __webpack_public_path__ + "static/media/billboard_banner_default_375@2x.d733005d.png";